import { DataModel } from "common/models/utility-models/base-model";

export class ApplicantsReportsModel extends DataModel {
    selectedRegion: string = '';
    selectedState: string = '';
    selectedBranch: string = '';
    selectedGender: string = '';
    selectedStatus: string = '';
}